import { defineComponent, reactive } from "vue";
export default defineComponent({
  props: {
    useDefault: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const state = reactive({
      showMark: true
    });
    const handleCloseMark = () => {
      state.showMark = false;
    };
    const handleHandIn = () => {
      window.open("https://cloud.jdl.com/admin/#/upgrade/work-order/new?typeCode=azsI4P6TAR", "__blank");
    };
    return {
      state,
      handleCloseMark,
      handleHandIn
    };
  }
});